import ReferencialDto from '../../../dto/ReferencialDto'

export default class DtoCulturesFamily extends ReferencialDto {
    constructor(object) {
        super(object)
    }
}